import { useTranslation } from 'react-i18next';
import { Row } from '@tanstack/react-table';
import { ICal, ICalType } from 'models/ICal';
import { providerToLabelMap } from '../../CalendarImport.constants';

const ProviderCell = ({ row }: { row: Row<ICal> }) => {
  const { t } = useTranslation();
  const { type, name } = row.original;

  if (name) {
    return name;
  }

  // this should not happen, because if it's default, it should have a name, but to satisfy TypeScript and be safe:
  if (type === ICalType.DEFAULT) {
    return t(
      'pageAutomations.calendarTools.calendarImportSection.otherProvider',
    );
  }

  return providerToLabelMap[type];
};

export default ProviderCell;
